<template>
    <div>
        <span class="btn-text link-text" v-if="project._id" @click="showdialog = true; getTableData()">修改</span>
        <span class="btn-text link-text" v-else @click="showdialog = true; getTableData()">设置</span>
        <el-dialog
            title="项目列表"
            :visible.sync="showdialog"
            width="1200px">

            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" ref="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="楼盘名称">
                            <el-input v-model="form.name" maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="区域">
                            <el-select v-model="form.region" placeholder="请选择" size="mini">
                                <el-option :label="item.name" :value="item.name" v-for="(item, index) in regions" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="价格区间">
                            <el-input type="number" v-model="form.price.min" placeholder="最低价格"></el-input>
                            <span>-</span>
                            <el-input type="number" v-model="form.price.max" placeholder="最高价格"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tableData" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60"></el-table-column>
                        <el-table-column prop="name" label="楼盘名称" show-overflow-tooltip></el-table-column>
                        <el-table-column label="状态" show-overflow-tooltip align="center">
                            <template slot-scope="s">
                                <span class="text-success" v-if="s.row.putaway">上架</span>
                                <span class="text-danger" v-else>下架</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="region" label="区域" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="average_price" label="当前单价" show-overflow-tooltip>
                            <template slot-scope="s">
                                <span v-if="s.row.average_price">{{s.row.average_price}}元/㎡</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="80">
                            <template slot-scope="s">
                                <el-button type="primary" size="mini" @click="handleCurrentChange(s.row)" plain>关联</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>

        </el-dialog>
        
    </div>
</template>

<script>
export default {
    name: 'DynamicProject',
    data() {
        return {
            showdialog: false,
            id: '',
            form: {
                name: '',
                region: '',
                price: {
                    min: '',
                    max: '',
                }
            },
            tableData: [],
            pageNo: 1,
            pagesize: 14,
            total: 0,
            loading: false,
        }
    },
    props: {
        project: {
            type: Object,
            default: function(){
                return {};
            }
        },
        regions: {
            type: Array,
            default: function(){
                return [];
            }
        },
        eid: {
            type: String,
            default: '',
        },
        managedCity:{
            type:String,
            default:''
        },
        city:{
            type:String,
            default:''
        }
    },
    mounted () {
        if (this.eid) this.id = this.eid;
    },
    methods: {
        handleCurrentChange(row) {
            var params = {
                id: this.id,
                projectid: row._id['$oid']
            }
            this.$api.ProjectDynamicSetProject(params).then(
                data=>{
                    this.$message.success(data);
                    this.showdialog = false;
                }
            )
        },
        getTableData() {
            var params = {
                name: this.form.name,
                region: this.form.region,
                price: JSON.stringify(this.form.price),
                pageNo: this.pageNo,
                pagesize: this.pagesize,
                city: this.city?this.city:this.managedCity,
            };
            this.$api.getProjectList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tableData = list;
                    this.total = total;
                }
            )
        },
        confirm() {
            this.pageNo = 1;
            this.getTableData();
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTableData();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>